import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { DeliverynoteModel } from "./deliverynote.model";
import { DeliveryNoteService } from "./deliverynote.service";
import { InvoiceService } from "../invoice/invoice.service";
import * as FileSaver from 'file-saver';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DeliveryNoteDialogDeleteComponent } from './deliverynote-dialog-delete.component';
import { InvoiceDeliveryNotesConst } from '../const';
import { DummyComponent } from '../../../shared/dummy.component';
import { Utils } from '../../../shared/utils';
import { consts } from '../../../consts';
import { DeliveryNoteDialogPublishComponent } from './deliverynote-dialog-publish.component';
import { TableService } from '../../../shared/components/table/table.service';
import { ConceptService } from '../../concept/concept/concept.service';
import { PreinvoiceService } from '../preinvoice/preinvoice.service';
import { ConceptModel } from '../../concept/concept/concept.model';

@Component({
    selector: 'convfact-deliverynote-list',
    templateUrl: './deliverynote-list.component.html',
    styleUrls: ['./deliverynote.component.css'],
    standalone: false
})
export class DeliveryNoteListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  constructor(
    private router: Router,
    private deliverynoteService: DeliveryNoteService,
    private invoiceService: InvoiceService,
    private conceptService: ConceptService,
    private preinvoiceService: PreinvoiceService,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    public snackBar: MatSnackBar,
    private tableService: TableService
  ) { }

  dataSource: DeliverynoteModel[] = [];
  deliverynote: DeliverynoteModel;
  empty: boolean = false;
  ready: boolean = false;
  month: number = 0;
  year: number = 0;
  currentActivityUid: string;
  headerTable: any[] = InvoiceDeliveryNotesConst.headerTable;

  //Interacciones con la tabla------------------------------------------------------
  onPreInvoiceNumberClick(preInvoiceNumber) {
    this.pdf(preInvoiceNumber.uid); // Llamar a la función pdf con el uid de la preinvoice
  }

  onPreInvoiceIssuerClick(preInvoiceNumber) {
    this.deliverynoteService.loadData(preInvoiceNumber.uid).then(response => {
      this.deliverynote = response;
      if (this.deliverynote.invoiceNumber == null) {
        this.edit(preInvoiceNumber.uid);
      }
    })
  }
  //--------------------------------------------------------------------------------

  public export(selected): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    if (selected && selected.length < 1) {
      this.displayInfo('No tienes ningún albarán seleccionado');
      return;
    }

    /*Elminamos los que no pueden ser convertidos. */
    const dataSelected = this.dataSource.filter(row => selected.includes(row.uid) && row.convertedToInvoice == null);
    selected = dataSelected.map(row => row.uid);

    if (selected.length < 1) {
      this.displayInfo('Solo puedes convertir albaranes que no son facturas')
      return;
    }

    this.ready = false;
    this.invoiceService.convertDeliveryNoteInvoice(selected).then(response => {
      const deliveryNote = response['data'];

      const responseMessage = response['message'];

      if (!Utils.IsNullOrEmpty(responseMessage)) {
        this.ready = true;
        this.displayInfo(responseMessage);
        return;
      }

      //------------ Conceptos con números de serie ----------------//
      this.preinvoiceService.loadData(deliveryNote.uid).then(invoice => {
        this.conceptService.getListSerialNumbers().then(conceptsWithSerialNumbers => {
          const concepts: ConceptModel[] = conceptsWithSerialNumbers;
          let conceptUid: string;
          if (concepts.length > 0) {
            concepts.forEach(concept => {
              deliveryNote.invoiceLines.forEach(invoiceLine => {
                if (invoiceLine.product.includes(concept.name)) {
                  console.log("Concepto con número de serie encontrado en factura");
                  conceptUid = concept.uid;
                  this.conceptService.getSerialNumbers(concept.uid).then(serialNumbers => {
                    serialNumbers.forEach(serialNumber => {
                      if (invoiceLine.product.includes(serialNumber.serialNumber)) {
                        console.log("Número de serie encontrado en factura");
                        serialNumber.invoiceUid = invoice.uid;
                        serialNumber.invoiceNumber = invoice.invoiceNumber;
                        this.conceptService.modifySerialNumbers(serialNumber, concept.uid).then(response => {
                          console.log("Número de serie actualizado");
                        });
                      }
                    });
                  });
                }
              });
            });
          }
        });
      });
      //------------ Fin Conceptos con números de serie ----------------//

      this.ready = true;
      this.router.navigate(['/invoice/issued'])
    });
  }

  public pdf(uid: string): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.deliverynoteService.loadData(uid).then(response => {
      this.deliverynote = response;
      const fileName = this.deliverynote.preInvoiceNumber + "_" + this.deliverynote.receiverName + ".pdf";
      this.deliverynoteService.loadData(uid).then(response =>
        this.deliverynote = response);
      this.deliverynoteService.pdf(uid, consts.EMPTY_GUID).then(response => {
        FileSaver.saveAs(response, fileName);
      })
    })

  }

  public convertToInvoice(uid: string): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.dialog.open(DeliveryNoteDialogPublishComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe((result: string) => {
        this.router.navigate([result]);
      });
  }

  public create(): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.router.navigate(['/invoice/deliverynote/create']);
  }

  public edit(uid: string): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.router.navigate(['/invoice/deliverynote/edit/', uid]);
  }

  public delete(uid: string) {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.dialog.open(DeliveryNoteDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url);
      }
      );
  }

  public ngOnInit() {
    this.getList();
    this.getTotal();
  }

  public getList() {
    this.deliverynoteService.getList(this.currentPage, this.itemsPerPage).then(
      data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      }
    );
  }

  public getTotal() {
    this.deliverynoteService.getTotal().then(
      data => {

      }
    );
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public bookDeliveryNotes(selectedInvoices): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.ready = false;
    this.invoiceService.bookDeliveryNotes(selectedInvoices, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName("Excel_Albaranes"));
      this.ready = true;
    });
  }
  public bookDeliveryNotesProducts(selectedInvoices): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.ready = false;
    this.invoiceService.bookDeliveryNotesProducts(selectedInvoices, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName("Excel_Albaranes-Productos"));
      this.ready = true;
    });
  }
  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, 'Cerrar', options);
  }

  public duplicate(uid: string) {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.ready = false;

    this.deliverynoteService.duplicateDeliveryNotes(uid).then(
      (response: boolean) => {
        if (response) {
          this.dummy.redirectTo(this.router.url);
          this.ready = true;
        }
        else {
          this.ready = true;
        }
      }
    )
      .catch(err => {
        this.ready = true;
      });
  }

  public pdfMail(uid: string): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.invoiceService.pdfMail(uid).then(response => {
      this.displayInfo(response);
      this.dummy.redirectTo(this.router.url);
    }).catch(error => {
      this.displayInfo(error.error['message']);
    })

  }
  public trackByIndex(i: number) { return i; }

}
